export const getOrCreateInFlightRequest = <T>(
  requestsMap: Map<string, Promise<T>>,
  requestKey: string,
  createRequest: () => Promise<T>
): Promise<T> => {
  const existingRequest = requestsMap.get(requestKey)
  if (existingRequest) {
    return existingRequest
  }

  const requestPromise = (async () => {
    try {
      return await createRequest()
    } finally {
      requestsMap.delete(requestKey)
    }
  })()

  requestsMap.set(requestKey, requestPromise)
  return requestPromise
}

export class InFlightRequestManager {
  private readonly requests = new Map<string, Promise<unknown>>()

  public constructor(private readonly scope: string) {}

  public run<T>(
    operation: string,
    requestKey: string,
    createRequest: () => Promise<T>
  ): Promise<T> {
    const scopedKey = `${this.scope}:${operation}:${requestKey}`
    const existingRequest = this.requests.get(scopedKey) as Promise<T> | undefined
    if (existingRequest) {
      return existingRequest
    }

    const requestPromise = (async () => {
      try {
        return await createRequest()
      } finally {
        this.requests.delete(scopedKey)
      }
    })()

    this.requests.set(scopedKey, requestPromise)
    return requestPromise
  }

  public clear(operation?: string): void {
    if (!operation) {
      this.requests.clear()
      return
    }

    const operationPrefix = `${this.scope}:${operation}:`
    Array.from(this.requests.keys()).forEach((key) => {
      if (key.startsWith(operationPrefix)) {
        this.requests.delete(key)
      }
    })
  }
}
